const switchContainerTokens = () => ({
  sizes: {
    medium: {
      width: '42px',
      height: '26px',
    },
  },
});

export default switchContainerTokens;
